/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { Card, CardBody, Flex } from "@chakra-ui/react";
import { FaEdit } from "react-icons/fa";
import { useUser } from "../../hooks/use-user";
import { Paths } from "../../routes/paths";
import { HasPermission } from "../../utils/helper";
import { useGetConsumablesPaginated } from "../../services/consumables";
import { initialDataState } from "./constants";
// eslint-disable-next-line import/no-unresolved
import ConsumableFilterBarV2 from "components/consumables/filter-bar";
// eslint-disable-next-line import/no-unresolved
import Loader from "components/PageLoader";

export default function ConsumablesList() {
  const [consumables, setConsumables] = useState([]);
  const [dataState, setDataState] = useState(initialDataState);
  const user = useUser();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    searchCriteria: "",
    selectedCashCenterId: user.CashCenterId,
    selectedCustomerId: "",
  });

  const pageSize = 25;
  const {
    mutate: getConsumablesList,
    isSuccess: consumablesListAvailable,
    data: consumablesList,
    isPending: gettingConsumablesList,
    reset: resetConsumablesListError,
  } = useGetConsumablesPaginated();

  useEffect(() => {
    if (consumablesListAvailable) {
      setConsumables(consumablesList.data.data);
      setTotalRecords(consumablesList.data.totalRecords);
      resetConsumablesListError();
    }
  }, [consumablesListAvailable]);
  // console.log("consumables", consumables);

  useEffect(() => {
    setCurrentPage(1);
    getConsumablesList({
      pageNumber: currentPage,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria,
      operationDate: new Date(),
      cashCenterId: filters.selectedCashCenterId || "",
    });
  }, [filters]);

  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getConsumablesList({
      pageNumber: _page,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria,
      operationDate: new Date(),
      cashCenterId: filters.selectedCashCenterId || "",
    });
  };

  const viewCell = ({ dataItem }) => {
    return (
      <>
        {canViewDetails ? (
          <td>
            <Flex
              as={Link}
              to={`${Paths.consumableDetails}/${dataItem.consumableId}`}
              style={{ cursor: "pointer", color: "blue" }}
              w="100%"
              title="View"
            >
              <>{dataItem.sealNo}</>
            </Flex>
          </td>
        ) : (
          <>{dataItem.sealNo}</>
        )}
      </>
    );
  };

  const editCell = ({ dataItem }) => {
    return (
      <td>
        <Flex
          as={Link}
          to={`${Paths.editConsumable}/${dataItem.consumableId}`}
          justifyContent="center"
          style={{ cursor: "pointer" }}
          w="100%"
          title="Edit Consumables"
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const canEdit = useMemo(() => {
    return HasPermission(user, "Consumable", "Edit");
  }, [user]);

  const canViewDetails = useMemo(() => {
    return HasPermission(user, "Consumable", "View");
  }, [user]);

  return (
    <Flex className="main-container">
      {gettingConsumablesList ? <Loader /> : <></>}
      <Card m="20px">
        <CardBody>
          <ConsumableFilterBarV2
            getList={(filter, cashCenterId) => {
              setFilters({
                searchCriteria: filter,
                selectedCashCenterId: cashCenterId,
              });
            }}
          />
          <Grid
            data={process(consumables || [], dataState)}
            {...dataState}
            onDataStateChange={(e) => {
              setDataState(e.dataState);
            }}
            filterable
            sortable
            pageable
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
          >
            <Column
              title="Seal No"
              field="sealNo"
              cell={viewCell}
              width={200}
            />
            <Column title="Description" field="description" />
            <Column title="Status" field="status" />
            {/* <Column
                filterable={false}
                title="View Summary"
                headerClassName="text-center"
                className="text-center"
                width={140}
                cell={summaryCell}
              /> */}
            {canEdit > 0 ? (
              <Column
                filterable={false}
                title="Edit"
                headerClassName="text-center"
                className="text-center"
                width={80}
                cell={editCell}
              />
            ) : (
              <></>
            )}
            {/* {canDelete ? (
                <Column
                  filterable={false}
                  title="Delete"
                  headerClassName="text-center"
                  className="text-center"
                  width={80}
                  cell={deleteCell}
                />
              ) : (
                <></>
              )} */}
            {/* <Column width="100" title="Actions" className="text-center" filterable={false} cell={EditButtonCell} /> */}
          </Grid>
        </CardBody>
      </Card>
    </Flex>
  );
}
